import {
    HttpErrorResponse,
    HttpStatusCode,
} from '@angular/common/http';

export function isUnauthorizedHttpError(error: unknown): boolean {
    return error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized;
}